.wrapper {
  position: relative;
}

/* --- Trigger button --- */

.root {
  align-items: center;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 14px;
  gap: 6px;
  min-width: 0;
  outline: none;
  overflow: hidden;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
  width: 100%;

  &:hover {
    border-color: var(--color-foreground);
  }

  &:focus-visible {
    border-color: var(--color-focus);
    box-shadow: 0 0 0 2px var(--color-focus);
  }
}

.root-size-sm {
  height: 32px;
  padding: 0 10px;
}

.root-size-compact {
  border-radius: 8px;
  font-size: 13px;
  gap: 4px;
  height: 28px;
  padding: 0 8px;
}

.root-size-default {
  height: 36px;
  padding: 0 12px;
}

.root-size-lg {
  height: 40px;
  padding: 0 14px;
}

.root-is-open {
  border-color: var(--color-focus);
  box-shadow: 0 0 0 2px var(--color-focus);
}

.root-is-disabled {
  background: var(--color-secondary);
  cursor: not-allowed;
  opacity: 0.6;
}

.icon {
  color: var(--color-muted);
  flex-shrink: 0;
}

.value {
  color: var(--color-foreground);
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.placeholder {
  color: var(--color-placeholder);
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chevron {
  color: var(--color-muted);
  flex-shrink: 0;
  height: 14px;
  transition: transform 0.15s;
  width: 14px;
}

.chevronOpen {
  transform: rotate(180deg);
}

/* --- Dropdown panel --- */

.dropdown {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  left: 0;
  max-height: 260px;
  min-width: 100%;
  overflow: hidden;
  padding: 4px;
  position: absolute;
  top: calc(100% + 4px);
  width: max-content;
  z-index: 50;
}

.dropdown-top {
  bottom: calc(100% + 4px);
  top: auto;
}

.dropdown-portal {
  // Position driven by inline left/right/top/bottom — reset the base absolute
  // defaults (`left: 0; top`) so they don't fight right-alignment.
  left: auto;
  max-width: min(360px, calc(100vw - 16px));
  min-width: 0;
  right: auto;
  top: auto;
  // Above the Modal overlay (z-index: 2000) so a portaled dropdown opened
  // from inside a modal renders in front of it, not behind. The portal is at
  // document.body level, so this never traps non-modal usages.
  z-index: 2100;
}

.dropdown-compact {
  border-radius: 8px;
  max-height: 220px;
  padding: 3px;
}

.dropdown-compact .searchRow {
  margin: -3px -3px 3px;
  padding: 6px 8px;
}

.dropdown-compact .searchInput,
.dropdown-compact .option {
  font-size: 13px;
}

.dropdown-compact .option {
  padding: 4px 8px;
}

.optionList {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.searchRow {
  align-items: center;
  border-bottom: 1px solid var(--color-border);
  display: flex;
  gap: 6px;
  margin: -4px -4px 4px;
  padding: 8px 10px;
}

.searchIcon {
  color: var(--color-muted);
  flex-shrink: 0;
  height: 14px;
  width: 14px;
}

.searchInput {
  background: transparent;
  border: none;
  color: var(--color-foreground);
  flex: 1;
  font-family: inherit;
  font-size: 14px;
  outline: none;
  padding: 0;

  &::placeholder {
    color: var(--color-placeholder);
  }
}

/* --- Option --- */

.option {
  align-items: center;
  background: none;
  border: none;
  border-radius: 6px;
  color: var(--color-foreground);
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  gap: 6px;
  padding: 6px 10px;
  text-align: left;
  transition: background-color 0.1s;
  width: 100%;

  &:hover {
    background: var(--color-surface);
  }
}

.optionSelected {
  background: var(--color-surface);
  font-weight: 400;
}

.check-slot {
  align-items: center;
  display: inline-flex;
  flex-shrink: 0;
  height: 16px;
  justify-content: center;
  width: 16px;
}

.optionLabel {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.checkIcon {
  color: var(--color-foreground);
  flex-shrink: 0;
  height: 16px;
  width: 16px;
}

.empty {
  color: var(--color-muted);
  display: block;
  font-size: 13px;
  padding: 12px;
  text-align: center;
}

.dropdown-footer {
  border-top: 1px solid var(--color-border);
  flex-shrink: 0;
  padding: 4px;
}
